import { createColumnHelper } from '@tanstack/react-table';

import { TableNetwork } from './types';

export const columnHelper = createColumnHelper<TableNetwork>();
